<template>
    <form @submit.prevent="submit" class="form">
        <div class="form-group form-row justify-content-sm-center">
            <div class="col-xs-12 col-sm-6 col-md-7 col-xl-8">
                <input type="text" :value="code" @change="$emit('update:code', $event.target.value)"
                       minlength="4" maxlength="30" class="form-control"
                       placeholder="z.B. GA-XXXX-XXXX"
                       required autofocus
                       aria-label="z.B. GA-XXXX-XXXX" />
            </div>

            <div class="col-xs-12 col-sm-auto text-center text-sm-left">
                <button class="btn btn-primary btn-submit" type="submit" :disabled="loading">
                    <span>Abschicken</span>
                </button>
            </div>
        </div>
        <div class="form-row justify-content-sm-center">
            <label class="col">
                <input type="checkbox" v-model="acceptCancellationRestriction" required />
                Ich habe zur Kenntnis genommen, dass ich nach Abruf des zusätzlichen Gutscheins den ursprünglichen Kauf nicht mehr stornieren kann
            </label>
        </div>
        <b class="form-text">Jetzt Rabatt auf Ihren nächsten Einkauf sichern!</b>
        <div class="form-row justify-content-sm-center">
          <label class="col">
            <input type="checkbox" v-model="subscribe" />
            Ja, den Newsletter der Animod GmbH erhalten und einen Rabattcode erhalten!
          </label>
        </div>
        <div v-if="subscribe" class="form-row justify-content-sm-center">
            <div class="col-xs-12 col-sm-6 col-md-7 col-xl-8">
                <input
                  :value="email" @change="$emit('update:email', $event.target.value)"
                  type="email"
                  class="form-control"
                  placeholder="E-Mail-Adresse"
                  aria-label="E-Mail-Adresse"
                />
            </div>
            <div class="col-xs-12 col-sm-auto text-center text-sm-left">
                <button class="invisible btn btn-primary btn-submit" type="submit" :disabled="loading">
                    <span>Abschicken</span>
                </button>
            </div>
        </div>

        <small id="gdpr-notice"
               class="form-text text-muted">
            Durch Abschicken dieses Formulars stimmen Sie der Speicherung und Verarbeitung Ihrer Daten gemäß unserer
            <a href="https://www.animod.de/c/datenschutz" target="_blank" rel="noopener">
                Datenschutzerklärung
            </a> zu.
        </small>
    </form>
</template>

<script>
    export default {
        name: 'Form',
        components: {},
        props: {
            loading: Boolean,
            code: String,
            email: String
        },
        data() {
          return {
            subscribe: false,
          };
        },
        computed: {},
        methods: {
            submit() {
                this.$emit('submit', this.code, this.email);
            }
        },
        watch: {
            subscribe: function (subscribe) {
                if(!subscribe) {
                    this.$emit('update:email', null)
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "~bootstrap/scss/_functions.scss";
    @import "~bootstrap/scss/_variables.scss";
    @import "~bootstrap/scss/mixins/breakpoints";

    $primary-color:  hsl(25, 100%, 60%);

    .form {
        .btn-submit {
            @include media-breakpoint-down(xs) {
                display: block;
                margin: 1.25rem auto 0;
            }
        }

        a:not(.btn-primary) {
            color: $primary-color;
        }

        .btn-primary {
            background-color: $primary-color;
            background-image: linear-gradient(180deg, hsl(25, 100%, 65%), hsl(25, 100%, 60%));
            border: none;
            box-shadow: 0 0.0625rem 0.1875rem 0 rgba(0,0,0,.2);
            color: hsl(0, 0%, 100%);
            font-weight: 700;
            letter-spacing: .0625rem;
            text-transform: uppercase;
        }
    }
</style>
